module.exports = __webpack_public_path__ + "img/s8Bg1.bc075d1a.jpg";